import { __ } from "src/libs/utilities"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import Panel from "../../UIX/Panel"
import { PanelData } from "../../UIX/interface"
import { LayerHeader } from "./layers-form/LayerHeader"
import { Layers } from "./layers-form/Layers"

/* Protopia Ecosystem component */
export interface ILayersFormProps {
   
}
const LayersForm = (props: ILayersFormProps): JSX.Element => { 
    const { layersPositions, isEdit, isLayers, isLayersTread }     = useLandingConsoleStore( (state: ILandingConsoleStore) => state )

    const onPosition = ( x:number, y: number, w: number, h: number ) => {
        useLandingConsoleStore.setState({layersPositions:{ x, y, w, h }})
    }
    const onThread = (bool: boolean) => {
        useLandingConsoleStore.setState({isLayersTread: bool})
    }
    return isLayers && isEdit
        ?
        <Panel 
            x={ layersPositions?.x }
            y={ layersPositions?.y }
            w={ layersPositions?.w }
            h={ layersPositions?.h }
            isOpen={true}
            id="landing-layers"
            onClose={() => useLandingConsoleStore.setState({ isLayers: false })}
            onPosition={ onPosition }
            onThread={ onThread }
            isTread={ isLayersTread }
            header={<LayerHeader />}
            activeId={"section"}
            data={
                [
                    {
                        title: __(`Sections`),
                        icon: "/assets/img/landing/layers.svg",
                        data: <Layers />,
                        id: "section"
                    } as PanelData,
                    {
                        title: __(`Settings`),
                        icon: "/assets/img/landing/landing-settings.svg",
                        data: <Layers />,
                        id: "landing-settings"
                    } as PanelData,
                ]
            }
        />
        :
        <></>
}
export default LayersForm




